import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { simulationCaseCacheKeys } from "./constants";
import type {
  PutSimulationCaseProps,
  SaveSimulationCaseErrors,
  SimulationCase,
  SimulationItemResponse,
} from "./types";

export const putSimulationCase = reactQueryMutationAdapter(
  simulationCaseCacheKeys,
  createMutationFetcherFunctionWithShadowError<SaveSimulationCaseErrors>()(
    ({ appGroupId, id, body }: PutSimulationCaseProps): Promise<SimulationItemResponse<SimulationCase>> =>
      fetch(`/${appGroupId}/conversational/simulation/cases/${id}`, "PUT", body, undefined, {
        propagateFetchRequestError: false,
      })
  )
);
